module.exports = __webpack_public_path__ + "static/media/about.02480731.svg";